import { render, staticRenderFns } from "./MatchSimilarity.vue?vue&type=template&id=0385de1a&"
import script from "./MatchSimilarity.vue?vue&type=script&lang=js&"
export * from "./MatchSimilarity.vue?vue&type=script&lang=js&"
import style0 from "./MatchSimilarity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports